import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService) {
        
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if(req.url.indexOf('auth/login') >= 0) {
            return next.handle(req);
        }
  
        const copiedReq = req.clone({
            setHeaders: {
                Authorization: 'Bearer ' + this.authService.jwt
            }
        });

        return next.handle(copiedReq);
    }

}
